import { Box } from '@mui/material';
import { MdAssessment } from 'react-icons/md';
import { getServiceLogo } from './serviceIcons';

export default function ReportServiceIcon({ service, fallback, size = 44 }) {
    const logo = getServiceLogo(service);
    return <Box component="span" aria-hidden="true" sx={{ width: size, height: size, flexShrink: 0, borderRadius: size > 32 ? 2 : 1, bgcolor: '#fff', display: 'inline-grid', placeItems: 'center', p: size > 32 ? 0.75 : 0.25, border: '1px solid #E2E8F0', color: '#475569', '& svg': { width: '100%', height: '100%' } }}>
        {logo ? <Box component="img" src={logo} alt="" sx={{ width: '100%', height: '100%', objectFit: 'contain' }} /> : fallback || <MdAssessment />}
    </Box>;
}
